var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{attrs:{"variant":("light-" + (_vm.matchedOption.variant || 'primary'))}},[_vm._v(" "+_vm._s(_vm.matchedOption.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }